export const RECOVERY_MARKER_KEY = 'agc_password_recovery_verified'
export const RECOVERY_MARKER_MAX_AGE_MS = 60 * 60 * 1000

export type RecoveryMarkerPayload = {
  userId: string
  verifiedAtMs: number
}

export function parseRecoveryMarker(raw: string | null): RecoveryMarkerPayload | null {
  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw) as { userId?: unknown; verifiedAtMs?: unknown }
    if (typeof parsed.userId !== 'string' || parsed.userId.length === 0) {
      return null
    }
    if (typeof parsed.verifiedAtMs !== 'number' || !Number.isFinite(parsed.verifiedAtMs)) {
      return null
    }

    return {
      userId: parsed.userId,
      verifiedAtMs: parsed.verifiedAtMs,
    }
  } catch {
    return null
  }
}

export function isRecoveryMarkerValid(
  marker: RecoveryMarkerPayload | null,
  userId: string | null,
  nowMs: number = Date.now(),
): boolean {
  if (!marker || !userId) {
    return false
  }

  if (marker.userId !== userId) {
    return false
  }

  if (marker.verifiedAtMs > nowMs) {
    return false
  }

  return nowMs - marker.verifiedAtMs <= RECOVERY_MARKER_MAX_AGE_MS
}

export function setRecoveryMarker(marker: RecoveryMarkerPayload) {
  if (typeof window === 'undefined') return
  window.sessionStorage.setItem(RECOVERY_MARKER_KEY, JSON.stringify(marker))
}

export function clearRecoveryMarker() {
  if (typeof window === 'undefined') return
  window.sessionStorage.removeItem(RECOVERY_MARKER_KEY)
}

export function hasValidRecoveryMarkerForUser(userId: string | null) {
  if (typeof window === 'undefined') return false

  const marker = parseRecoveryMarker(window.sessionStorage.getItem(RECOVERY_MARKER_KEY))
  const valid = isRecoveryMarkerValid(marker, userId)

  if (!valid) {
    window.sessionStorage.removeItem(RECOVERY_MARKER_KEY)
  }

  return valid
}
